import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  addLocationData,
  deleteLocation,
  getLocationChart,
  getLocationOptions,
  locationByid,
  updateLocations,
} from "../../Api/services/locationService";

const locationSlice = createSlice({
  name: "locations",
  initialState: {
    error: null,
    loading: false,
    locationoptions: null,
    locationData: null,
    locationSignleData: null,
    getLocationLoading: false,
    detailsviewpageeditdata: null,
  },
  reducers: {
    // Reducer to set location data
    setlocationDetails: (state, action) => {
      state.detailsviewpageeditdata = action.payload;
    },
  },
  extraReducers: (builder) => {
    //add benefit
    builder
      .addCase(addLocationData.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addLocationData.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addLocationData.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //locations options
    builder
      .addCase(getLocationOptions.pending, (state) => {
        return {
          ...state,
          //loading: true,
        };
      })
      .addCase(getLocationOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          locationoptions: action.payload,
        };
      })
      .addCase(getLocationOptions.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          error: action.payload,
        };
      });
    //locations chart view data
    builder
      .addCase(getLocationChart.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getLocationChart.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          locationData: action.payload,
          loading: false,
        };
      })
      .addCase(getLocationChart.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          error: action.payload,
          loading: false,
        };
      });

    //delete locations
    builder
      .addCase(deleteLocation.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deleteLocation.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //update location data
    builder
      .addCase(updateLocations.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateLocations.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateLocations.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get location data by id
    builder
      .addCase(locationByid.pending, (state) => {
        return {
          ...state,
          getLocationLoading: true,
        };
      })
      .addCase(locationByid.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          locationSignleData: action.payload,
          getLocationLoading: false,
        };
      })
      .addCase(locationByid.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          error: action.payload,
          getLocationLoading: false,
        };
      });
  },
});

export const { setlocationDetails } = locationSlice.actions;
export default locationSlice.reducer;
